import { baseApi } from "@/shared/api/base";
import type { LoginCredentials, Session } from "../model/types";
import { removeStoredSession } from "./authStorage";

export const login = async (
  credentials: LoginCredentials,
): Promise<Session> => {
  // TODO: api-contarctに定義され次第、置き換える
  // TODO: その際にentitiesには置かず、直接api-contarctをimportするようにする
  const response = await baseApi.post("/api/auth/sign_in", credentials);
  const responseData = response.data.data;

  const session: Session = {
    tokens: {
      "access-token": responseData["access-token"],
      "token-type": responseData["token-type"],
      client: responseData.client,
      expiry: responseData.expiry,
      uid: responseData.uid,
      authorization: responseData.authorization,
    },
    user: {
      name: responseData.name,
      role: responseData.role,
      email: responseData.email,
      id: responseData.id,
      companyId: responseData.company_id,
      companyName: responseData.company_name,
    },
  };

  return session;
};

export const logout = async (): Promise<void> => {
  removeStoredSession();
  await baseApi.delete("/api/auth/sign_out");
};
